import React, { Component } from 'react';
import ImageAPI from '../../../api/ImageAPI';
import { browserHistory } from 'react-router';
import logo from '../../../images/logo.png';
import Image from '../../../components/helpers/Image.jsx';
import './ChromaticContainer.css';

export default class ChromaticContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      example: undefined,
      loading: true
    };
  }
  goToTwitter() {
    window.open('https://www.twitter.com/mixfont', '_blank');
  }

  goToChromaticHome() {
    browserHistory.push('/chromatic');
  }

  componentDidMount() {
    ImageAPI.getChromaticFont((response) => {
      console.log(response);
      this.setState({
        example: response,
        loading: false,
      });
    });
  }

  render () {
    const {
      children
    } = this.props;
    let clonedChildren = null;
    if (children) {
      clonedChildren = React.cloneElement(children, {
        example: this.state.example,
        loading: this.state.loading
      });
    }

    return (
      <div>
        <div className="splash-background">
          <div className="chromatic-header">
            <div className="chromatic-header-content">
              <div className="splash-header-logo"
                onClick={this.goToChromaticHome}>
                <div className="chromatic-mixfont-text">Fonts Meet Images</div>
              </div>
              <div className="splash-header-links">
                <div className="chromatic-project-text">
                  By <div className="chromatic-mixfont-text"
                  onClick={this.goHome}>MIXFONT</div>
                </div>
                <Image src={logo} className="chromatic-header-logo-image" />
              </div>
            </div>
          </div>
        </div>
        {clonedChildren}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/chromatic/ChromaticContainer.jsx